import { dom } from '@fortawesome/fontawesome-svg-core'

export function setup() {
  dom.watch({
    observeMutationsRoot: document,
  })
}